import { render } from "./EditCourseForBatch.vue?vue&type=template&id=2dbd6448&scoped=true"
import script from "./EditCourseForBatch.vue?vue&type=script&lang=js"
export * from "./EditCourseForBatch.vue?vue&type=script&lang=js"

import "./EditCourseForBatch.vue?vue&type=style&index=0&id=2dbd6448&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dbd6448"]])

export default __exports__